import { Divider, Panel } from 'rsuite';
import React from 'react';

export const SmtpAccountSetupInstructions = () => (
  <Panel header="Respond to Reservation Emails from Your Inbox" bordered>
    <p>
      FBM can now send automated email notifications to guests for reservation
      updates. This applies to reservations created through the Portal as well
      as those created directly within FBM.
    </p>

    <p>
      When creating or updating a reservation internally, you will see a
      confirmation prompt asking whether you would like to notify the guest
      about the change. You may:
    </p>

    <ul>
      <li>
        Choose <strong>Yes</strong> to send the notification
      </li>
      <li>
        Choose <strong>No</strong> to skip sending the email
      </li>
      <li>
        Provide an alternative email address where the notification should be
        sent
      </li>
    </ul>

    <p>
      If you connect your Gmail account, guest replies to these emails will be
      delivered directly to your inbox, allowing you to respond using your
      regular email app (desktop or mobile).
    </p>

    <p>
      Connecting your email is optional. However, if you do not connect your
      Gmail account, you will not receive guest replies in your inbox or be able
      to respond directly from your email client.
    </p>

    <p>
      <strong>Currently, only Gmail accounts are supported.</strong>
    </p>

    <Divider />

    <p>
      <strong>IMPORTANT:</strong> This feature requires that the Email field in
      your Calendar settings is set to <strong>Show</strong>.
    </p>

    <Divider />

    <h6>Resources:</h6>
    <ul>
      <li>
        Learn how this feature works: &nbsp;
        <a
          href="https://fbm-support.freshdesk.com/support/solutions/articles/159000426843-reservation-email-notification-feature"
          target="_blank"
          rel="noopener noreferrer"
        >
          Reservation Email Notification Feature
        </a>
      </li>
      <li>
        Connect your Gmail account setup guide: &nbsp;
        <a
          href="https://fbm-support.freshdesk.com/support/solutions/articles/159000426475-how-to-link-your-gmail-to-fbm-for-sending-receiving-emails"
          target="_blank"
          rel="noopener noreferrer"
        >
          How to Link Your Gmail to FBM for Sending & Receiving
        </a>
      </li>
      <li>
        Watch Setup Video Walkthrough: &nbsp;
        <a
          href="https://fbm-support.freshdesk.com/support/solutions/articles/159000426942-link-gmail-to-fbm-video-walkthrough"
          target="_blank"
          rel="noopener noreferrer"
        >
          Link Gmail to FBM Video Walkthrough &nbsp;
        </a>
      </li>
    </ul>
    <br />
    <br />
    <h6>
      <span role="img" aria-label="Support">
        🔧
      </span>{' '}
      Support
    </h6>
    <p>
      If you need assistance setting up or using this feature, our team is here
      to help.
    </p>
    <p>You can reach us through the following:</p>
    <ul>
      <li>
        <span role="img" aria-label="Email">
          📧
        </span>{' '}
        Email: support@soxboxsoftware.com
      </li>
      <li>
        <span role="img" aria-label="Ticket">
          📝
        </span>{' '}
        Submit a ticket:{' '}
        <a
          href="https://fbm-support.freshdesk.com/support/tickets/new"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://fbm-support.freshdesk.com/support/tickets/new
        </a>
      </li>
    </ul>
  </Panel>
);
